(() => {
  let opener;
  let active;
  const close = () => { if (active?.open) active.close(); };
  const open = (dialog, source) => {
    if (active?.open) active.close();
    opener = source;
    active = dialog;
    dialog.showModal();
    document.body.classList.add('fh-hive-modal-open');
    dialog.querySelector('.fh-hive-close').focus();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (link.classList.contains('fh-hive-full-page')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.endsWith('/pages/meet-the-hive') || !url.hash) return;
    const handle = decodeURIComponent(url.hash.slice(1));
    const dialog = document.getElementById('fh-hive-' + handle);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    link.closest('header-menu')?.querySelector('details')?.removeAttribute('open');
    const drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event);
    open(dialog, link);
  }, true);
  document.querySelectorAll('.fh-hive-dialog').forEach(dialog => {
    dialog.querySelector('.fh-hive-close').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('fh-hive-modal-open');
      if (opener?.isConnected) opener.focus();
      active = null;
    });
  });
})();


(() => {
  const choices = [...document.querySelectorAll('.fh-reaction-choice')];
  const hide = choice => {
    choice.querySelector('.fh-bee-bubble').hidden = true;
    choice.querySelector('[data-fh-reaction-toggle]').setAttribute('aria-expanded', 'false');
    choice.dataset.pinned = '';
  };
  const show = choice => {
    choices.forEach(other => { if (other !== choice) hide(other); });
    choice.querySelector('.fh-bee-bubble').hidden = false;
    choice.querySelector('[data-fh-reaction-toggle]').setAttribute('aria-expanded', 'true');
  };
  choices.forEach(choice => {
    const button = choice.querySelector('[data-fh-reaction-toggle]');
    choice.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') show(choice); });
    choice.addEventListener('pointerleave', () => { if (!choice.dataset.pinned && !choice.contains(document.activeElement)) hide(choice); });
    choice.addEventListener('focusin', () => show(choice));
    choice.addEventListener('focusout', event => { if (!choice.contains(event.relatedTarget)) hide(choice); });
    button.addEventListener('click', () => {
      if (choice.dataset.pinned) hide(choice);
      else { show(choice); choice.dataset.pinned = 'true'; }
    });
    choice.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        button.focus();
        hide(choice);
      }
    });
  });
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.fh-reaction-choice')) choices.forEach(hide);
  });
})();

(() => {
  const setup = root => {
    root.querySelectorAll('[data-fh-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('.fh-hive-picks');
      const previous = carousel.querySelector('[data-fh-carousel-prev]');
      const next = carousel.querySelector('[data-fh-carousel-next]');
      const update = () => {
        const overflow = track.scrollWidth - track.clientWidth;
        previous.disabled = overflow < 2 || track.scrollLeft < 2;
        next.disabled = overflow < 2 || track.scrollLeft >= overflow - 2;
      };
      const move = direction => {
        const card = track.querySelector('.fh-hive-pick');
        if (!card) return;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + 14), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
